module.exports = __webpack_public_path__ + "static/media/notapproved.87eff985.svg";